<template>
  <el-container class="index-con">
    <div class="index-header" style="border-bottom: solid 1px #e6e6e6;">
      <navcon></navcon>
    </div>
    <div class="index-page"></div>
    <div style="background-color: #e6e6e6;">
      <div class="main-con" >
        <!-- 面包屑导航 -->
        <div class="breadcrumb">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>海量数据</el-breadcrumb-item>
            <el-breadcrumb-item>个人中心</el-breadcrumb-item>
            <el-breadcrumb-item>我的考试</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="exam-contetn">
          <div style="flex: 1;">
            <div class="exam-contetn-item">
              <p class="exam-contetn-item-title">{{examName}}</p>
              <p class="exam-contetn-item-score">
                <span>总分：{{totalScore}}分</span>
                <span>时长：{{examDuration}}分钟</span>
              </p>
              <div class="exam-contetn-item-scantron">
                <p class="exam-contetn-item-scantron-p">
                  <span class="exam-contetn-item-scantron-card">答题卡</span>
                  <span class="exam-contetn-item-scantron-type">状态说明</span>
                </p>
                <div class="exam-contetn-item-scantron-state">
                  <div class="exam-contetn-item-scantron-state-imgs">
                    <p></p>
                    <span>已做</span>
                  </div>
                  <div class="exam-contetn-item-scantron-state-imgs">
                    <p class="p2"></p>
                    <span>未做</span>
                  </div>
                  <div class="exam-contetn-item-scantron-state-imgs">
                    <img src="../../assets/img/icon7.png" alt="">
                    <span>标记</span>
                  </div>
                </div>
              </div>
              <ul>
                <li v-for="item,index in examItem" :key="index" v-if="item.questionType!=5" :class="item.answerContent && item.answerContent.length>0?'curli':''" @click="onCount(index)">{{ index+1 }}
                  <img src="../../assets/img/icon7.png" alt="" v-if="item.flag == true">
                </li>
              </ul>
              <div class="exam-contetn-item-time">
                <p class="exam-contetn-item-time-text">剩余时间</p>
                <p class="exam-contetn-item-time-countdown">{{ timeLeft }}</p>
                <!-- <countdown class="exam-contetn-item-time-countdown" :countdownSeconds="expire" @end="submission"></countdown> -->
              </div>
            </div>
            <el-button  class="button" type="warning" style="width: 100%;height: 50px;background-color: #ff821c" @click="submission">提交试卷</el-button>
          </div>
          
          <!-- 试题 -->
          <div style="width: 75%;">
            <div class="exam-contetn-text">
              <div>
                <ul >
                  <li v-for="item,index in examItem" :key="index">
                    <!-- v-if="item.typeOrder==1 && isCount==index" -->
                    <div v-if="isCount==index">
                      <p class="exam-contetn-text-ranking">第{{index + 1}}题
                        <span v-if="item.questionType==1">【单选题】</span>
                        <span v-else-if="item.questionType==2">【多选题】</span>
                        <span v-else-if="item.questionType==3">【判断题】</span>
                        <span v-else-if="item.questionType==4">【填空题】</span>
                        <span v-else-if="item.questionType==6">【实践题】</span>
                      </p>
                      <div class="exam-contetn-text-title">
                        <p style="white-space: pre-wrap;">{{item.title}}（{{item.score}}分）</p>
                        <img :src="item.images" v-if="item.images">
                      </div>
                      <div class="exam-contetn-text-radio" >
                        <!-- 单选题 -->
                        <el-radio-group v-model="item.answerContent" v-if="item.questionType==1">
                          <el-radio :label="itemi.prefix" v-for="itemi,indexi in item.items" :key="indexi">{{ itemi.prefix + ' ' +itemi.content }}</el-radio>
                        </el-radio-group>
                        
                        <!-- 多选题 -->
                        <el-checkbox-group v-model="item.answerContent" v-else-if="item.questionType==2">
                          <el-checkbox  :label="itemi.prefix" v-for="itemi,indexi in item.items" :key="indexi">{{ itemi.prefix + ' ' +itemi.content }}</el-checkbox>
                        </el-checkbox-group>
                        
                        <!-- 判断题 -->
                        <el-radio-group v-model="item.answerContent" v-else-if="item.questionType==3">
                          <el-radio :label="itemi.prefix" v-for="itemi,indexi in item.items" :key="indexi">{{ itemi.prefix + ' ' +itemi.content }}</el-radio>
                        </el-radio-group>

                        <!-- 填空题 -->
                        <div v-else-if="item.questionType==4">
                          <div class="exam-contetn-text-input" v-for="itemi,indexi in item.correctArrayBlank" :key="indexi" >
                            <p>{{ indexi+1 }}.</p>
                            <el-input v-model="itemi.value" placeholder="请输入答案" @change="changes" @paste.native.capture.prevent="handlePaste"></el-input>
                          </div>
                        </div>

                        <!-- 解答题 -->
                        <!-- <quill-editor v-model="content" :options="editorOption" v-else></quill-editor> -->

                        <!-- 实践题 -->
                        <div v-else-if="item.questionType==6">
                          <div class="exam-contetn-text-input">
                            <!-- <p>{{ indexi+1 }}.</p> -->
                            <el-input type="textarea" v-model="item.answerContent" placeholder="请输入答案" @change="changes" @paste.native.capture.prevent="handlePaste"></el-input>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
             
              <div class="exam-contetn-button" v-if="this.isCount < this.examItem.length">
                <el-button style="background-color: #ff821c" type="warning" size="small" @click="previousQuestion" :disabled="isCount==0?true:false">上一题</el-button>
                <el-button size="small" class="buttons" @click="nextQuestion" :disabled="this.isCount>=this.examItem.length-1?true:false">下一题</el-button>
                <el-button size="small" class="buttons" @click="pointQuestion">标记</el-button>
              </div>
            <!-- <button @click="toggleFullScreen">Toggle Full Screen</button> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-footer class="index-footer" style="height: auto; background-color: #f0f4f7;border-top: solid 1px #e6e6e6">
      <footers></footers>
    </el-footer>
  </el-container>
</template>
<script>
// 导入组件
// import countdown from '../../components/countdown'
import navcon from '../../components/navcon.vue'
import footers from '../../components/footers.vue'

import { startExam, pointQuestion,saveAnswer,examFinish,tabRecord } from '../../api/userMG'
export default {
  name: 'examPage',
  // 注册组件
  components: {
    navcon,
    footers,
    // countdown
  },
  data() {
    return {
      examName:'',
      totalScore:0,
      examDuration:0,
      signId:'',
      ifPractice:0,
      showclass: 'asideshow',
      content:'', 
      editorOption: {
        placeholder: '请输入答案...'  // 设置placeholder
      },
      input:'',
      num:0, //切屏次数
      shouldPreventExitFullScreen:true,

      examItem:[],
      isCount:0,
      isIndex:0,
      answerContent:'',
      countdownSeconds:2,
      intervalId: null,

      questionsItem:[],
      correctArray:[],
      array:[],
      loading:''
    }
    
  },
  // activated() {
  //   // 监听beforeunload事件，提示用户是否离开页面
  //   window.addEventListener('beforeunload', this.beforeUnload);
  // },
  
  mounted() {
    
    this.$nextTick(() => {
      
      // 禁用复制
      document.onselectstart = new Function("event.returnValue=false");

      // 禁用右键菜单
      document.addEventListener('contextmenu', this.disableContextMenu);
 
      // 禁用F12
      document.addEventListener('keydown', this.disableF12);

      // 禁止退出全屏
      document.addEventListener("fullscreenchange", this.handleFullScreenChange);

      //切屏操作
      document.addEventListener('visibilitychange',this.beforeUnload,true);

    })
  },
  computed: {
    url() {
      return this.$store.getters.url;
    },
    // 计算属性将秒数转换为时分秒格式
    timeLeft() {
      let seconds = this.countdownSeconds;

      let minutes = Math.floor(seconds / 60);
      let hours = Math.floor(minutes / 60);
      seconds %= 60;
      minutes %= 60;
  
      return [hours, minutes, seconds]
        .map(this.pad)
        .join(':');
    }
  },
  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    // 组件销毁前移除事件监听
    document.removeEventListener('contextmenu', this.disableContextMenu);
    document.removeEventListener('keydown', this.disableF12);
    document.removeEventListener("fullscreenchange", this.handleFullScreenChange);
    document.removeEventListener('visibilitychange',this.beforeUnload,true) //销毁切屏监听事件
    // window.removeEventListener('beforeunload', this.beforeUnload);
  },
  created() {
    this.signId = this.$route.query.id;
    this.ifPractice = this.$route.query.ifPractice;
    this.getStartExam();
  },
  methods: {
    changes(e){
      console.log("5555555",e)
      this.examItem[this.isCount].answerContent = e;
    },
    // 补零操作
    pad(num) {
      return num.toString().padStart(2, '0');
    },
    // 更新倒计时
    updateCountdown() {
      if (this.countdownSeconds > 0) {
        this.countdownSeconds--;
      } else {
        clearInterval(this.intervalId);
        this.open();
      }
    },
    open() {
      this.$confirm('考试时间已到，请点击确定提交试卷', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '',
          type: 'warning',
          showCancelButton:false,
          showClose:false,
          closeOnClickModal:false,
          closeOnPressEscape:false
      }).then(() => {
          this.submission()
      })
    },
    // 获取考试题目
    async getStartExam(){
      let params = {
        signId:this.signId,
        ifPractice:this.ifPractice
      }
      const loading = this.$loading({
        lock: true,
        text: '加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      await startExam(params).then(res => {
        loading.close();
        this.countdownSeconds = res.data.expire;
        this.intervalId = setInterval(this.updateCountdown, 1000);
        this.examName = res.data.examName;
        this.totalScore = res.data.totalScore;
        this.examDuration = res.data.examDuration;
        this.examItem = res.data.questions;
        this.examItem.forEach((item,i) => {
          if(item.questionType==2){
            let answerContent = this.examItem[i].answerContent.split(',');
            let arr = answerContent.filter(str => str);
            console.log("arr",arr)
            item.answerContent = arr;
          }
          if(item.questionType==4){
            item.correctArrayBlank.forEach((item) =>{
              item.value = ''
            })
            if(item.answerContent){
              let answerContent = item.answerContent.split(',');
              answerContent.forEach((items,i) => {
                item.correctArrayBlank[i].value = items
              })
            }
          }
          // 默认未标记
          item.flag = false; 
        })
      })
    },

    // 上一题
    previousQuestion(){
      if(this.isCount > 0){
        this.saveAnswer(4);
      }
    },

    // 下一题
    nextQuestion(){
      if(this.isCount < this.examItem.length -1){
        this.saveAnswer(1);
      }
    },

    onCount(e){
      this.onIndex(e);
    },
    onIndex(e){
      this.isCount = this.isIndex;
      console.log(this.isCount)
      // 题id
      let questionId = this.examItem[this.isCount].id;

      // 题型
      let questionType = this.examItem[this.isCount].questionType;

      let params = {};
      let correct = '';
      let value = [];
      let array = [];
      let correctArray = [];

      // 单选题或者判断题
      if(questionType==1 || questionType==3){
        correct = this.examItem[this.isCount].answerContent;
        params = {
          signId:this.signId,
          questionId:questionId,
          answerContent:correct,
          ifPractice:this.ifPractice
        }
      }else if(questionType==2){
        correctArray = this.examItem[this.isCount].answerContent;
        params = {
          signId:this.signId,
          questionId:questionId,
          answerContent:correctArray?correctArray.join(','):'',
          ifPractice:this.ifPractice
        }
      }else if(questionType==4){
        value = this.examItem[this.isCount].correctArrayBlank;
        value.forEach((item,i) => {
          array.push(item.value)
        })
        let arr = array.filter(str => str).join(',');
        params = {
          signId:this.signId,
          questionId:questionId,
          answerContent:arr,
          ifPractice:this.ifPractice
        }
        // this.examItem[this.isCount].correctArrayBlank = arr;
      }else{
        correctArray = this.examItem[this.isCount].answerContent;
        params = {
          signId:this.signId,
          questionId:questionId,
          answerContent:correctArray,
          ifPractice:this.ifPractice
        }
      }
      this.examItem[this.isCount].questionsItem = params.answerContent;
      console.log("跳转提交答案",params)
      saveAnswer(params).then(res => {
        this.isIndex = e;
        this.isCount = this.isIndex;
      })
    },

    // 保存答案
    saveAnswer(e){
      // 题id
      let questionId = this.examItem[this.isCount].id;

      // 题型
      let questionType = this.examItem[this.isCount].questionType;

      let params = {};
      let correct = '';
      let correctArray = [];
      let value = [];
      let array = [];
      // 单选题或者判断题
      if(questionType==1 || questionType==3){
        correct = this.examItem[this.isCount].answerContent;
        params = {
          signId:this.signId,
          questionId:questionId,
          answerContent:correct,
          ifPractice:this.ifPractice
        }
      }else if(questionType==2){
        correctArray = this.examItem[this.isCount].answerContent;
        params = {
          signId:this.signId,
          questionId:questionId,
          answerContent:correctArray?correctArray.join(','):'',
          ifPractice:this.ifPractice
        }
      }else if(questionType==4){
        value = this.examItem[this.isCount].correctArrayBlank;
        value.forEach((item,i) => {
          array.push(item.value)
        })
        let arr = array.filter(str => str).join(',');
        params = {
          signId:this.signId,
          questionId:questionId,
          answerContent:arr,
          ifPractice:this.ifPractice
        }
        // this.examItem[this.isCount].correctArrayBlank = arr;
      }else{
        correctArray = this.examItem[this.isCount].answerContent;
        params = {
          signId:this.signId,
          questionId:questionId,
          answerContent:correctArray,
          ifPractice:this.ifPractice
        }
      }
      this.examItem[this.isCount].questionsItem = params.answerContent;
      if(e==2){
        console.log("直接提交答案",params)
        this.loading = this.$loading({
          lock: true,
          text: '',
          spinner: '',
          background: 'rgba(255, 255, 255, 0)'
        });
        saveAnswer(params).then(res => {
          this.loading.close();
          this.examFinish();
        })
      }else if(e==4){
        this.isCount--;
        console.log("上一题提交答案",params)
        saveAnswer(params).then(res => {

        })
      }else{
        this.isCount++;
        console.log("下一题提交答案",params)
        saveAnswer(params).then(res => {

        })
      }
    },

    // 提交
    submission(){
      let questionId = this.examItem[this.isCount].id;
      // 题型
      let questionType = this.examItem[this.isCount].questionType;
      let params = {};
      let correct = '';
      let correctArray = [];
      let value = [];
      let array = [];
      if(this.isCount == this.examItem.length-1){
        
        // 单选题或者判断题
        if(questionType==1 || questionType==3){
          correct = this.examItem[this.isCount].answerContent;
          params = {
            signId:this.signId,
            questionId:questionId,
            answerContent:correct,
            ifPractice:this.ifPractice
          }
        }else if(questionType==2){
          correctArray = this.examItem[this.isCount].answerContent;
          params = {
            signId:this.signId,
            questionId:questionId,
            answerContent:correctArray?correctArray.join(','):'',
            ifPractice:this.ifPractice
          }
        }else if(questionType==4){
          value = this.examItem[this.isCount].correctArrayBlank;
          value.forEach((item,i) => {
            array.push(item.value)
          })
          let arr = array.filter(str => str).join(',');
          params = {
            signId:this.signId,
            questionId:questionId,
            answerContent:arr,
            ifPractice:this.ifPractice
          }
        }else{
          correctArray = this.examItem[this.isCount].answerContent;
          params = {
            signId:this.signId,
            questionId:questionId,
            answerContent:correctArray,
            ifPractice:this.ifPractice
          }
        }
        this.examItem[this.isCount].questionsItem = params.answerContent;


        
        // let value = this.examItem[this.isCount].correctArrayBlank;
        // let array = [];
        // value.forEach((item,i) => {
        //   array.push(item.value)
        // })
        // let arr = array.filter(str => str).join(',');
        // console.log(arr)
        // params = {
        //   signId:this.signId,
        //   questionId:questionId,
        //   answerContent:arr,
        //   ifPractice:this.ifPractice
        // }
        // this.examItem[this.isCount].questionsItem = params.answerContent;
        
        console.log('最后一题',params)
        const loading = this.$loading({
          lock: true,
          text: '',
          spinner: '',
          background: 'rgba(255, 255, 255, 0)'
        });
        saveAnswer(params).then(res => {
          console.log('保存成功',res);
          loading.close();
          this.examFinishs(0);
        })
      }else if(this.isCount < this.examItem.length-1){
        this.saveAnswer(2)
      }
      
    },
    examFinish(){
      // return
      if(this.num>=2){
        this.examFinishs(1);
      }else{
        console.log("console.log(this.examItem)",this.examItem);
        if(this.timeLeft == '00:00:00'){
          this.examFinishs(2);
        }else{
          let flag = 0;
          let flag2 = 0;
          this.examItem.forEach((item,i) => {
            if(item.answerContent.length<=0){
              flag2 = 1;
              console.log("未做",item.answerContent.length)
              this.$confirm('还有题目未做, 是否确定提交试卷?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                this.examFinishs(0);
                flag = 1;
              })
            } 
          })
          console.log(flag,flag2)
          if(flag==0 && flag2==0){
            this.examFinishs(0);
          }
        }
      }
    },
    examFinishs(index){
      console.log("submitType: 0正常提交 1切屏被动提交 2时间已到自动提交",index)
      // index: 0正常提交 1切屏被动提交 2时间已到自动提交
      let params = {
        signId:this.signId,
        ifPractice:this.ifPractice,
        submitType:index
      }
      // console.log("提交")
      // return
      const loading = this.$loading({
        lock: true,
        text: '试卷提交中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      examFinish(params).then(res => {
        console.log('试卷提交',res);
        loading.close();
        if(res.code == 0){
          this.$message({
            type: 'success',
            message: '试卷已提交',
            offset:100
          });   
          setTimeout(() => {
            this.$router.go(-1)
          }, 1000);
        }
      })
    },

    // 标记题目
    pointQuestion(){
      console.log("下标",this.isCount)
      this.examItem[this.isCount].flag = !this.examItem[this.isCount].flag;
      this.$forceUpdate()
      // let questionId = this.examItem[this.isCount].id;
      // let ifPoint = this.examItem[this.isCount].ifPoint;
      // let params = {
      //   flag:ifPoint==1?0:1,
      //   questionId:questionId
      // }
      // pointQuestion(params).then(res => {
      //   console.log('标记题目',res);
      // })
    },

    disableContextMenu(event) {
      event.preventDefault();
    },
    disableF12(event) {
      if (event.key === 'F12') {
        event.preventDefault();
      }
    },
    onAnalysis(){
      this.$router.push({path:'/exam/analysis'})
    },
    toggleFullScreen() {
      if (!document.fullscreenElement) {
        this.requestFullScreen(document.documentElement);
      } else {
        if (document.exitFullscreen) {
          if(this.shouldPreventExitFullScreen){
            // 阻止退出全屏
            this.requestFullScreen(document.fullscreenElement);
          }else{
            document.exitFullscreen(); // 正常退出全屏
          }
        }
      }
    },
    requestFullScreen(element) {
      const requestMethod =
        element.requestFullScreen ||
        element.webkitRequestFullScreen ||
        element.mozRequestFullScreen ||
        element.msRequestFullscreen;
 
      if (requestMethod) {
        requestMethod.call(element);
      } else if (typeof window.ActiveXObject !== "undefined") { 
        // Older IE.
        const wscript = new ActiveXObject("WScript.Shell");
        if (wscript !== null) {
          wscript.SendKeys("{F11}");
        }
      }
    },
    handleFullScreenChange() {
      if (document.fullscreenElement && this.shouldPreventExitFullScreen) {
        // 阻止退出全屏
        this.requestFullScreen(document.fullscreenElement);
      }
    },
    handlePaste(event) {
      event.preventDefault(); // 阻止粘贴操作
      // 或者可以执行其他的处理逻辑
    },
    beforeUnload(event){
      // 用户准备离开当前页面时触发
      // 以下代码段被注释掉了，可能是为了防止用户在离开页面时弹出提示信息
      // const message = '您确定要离开吗？';
      // event.returnValue = message; // 兼容性设置
      // return message;
    
      // 检查文档的可见性状态
      console.log(document.visibilityState)
      // 当文档变为隐藏状态时，增加计数器
      if (document.visibilityState === 'hidden') {
        this.num++
      } else if (document.visibilityState === 'visible') {
        
        // 当用户打开或回到页面时
        let params = {
          signId:this.signId,
          ifPractice:this.ifPractice
        }
        tabRecord(params).then(res => {
          console.log('切屏记录',res);
        })
        if(this.num==1){
          this.$message({
            message: '已切屏'+this.num+'次,再次切屏将自动交卷', 
            type: 'warning',
            offset:100,
            duration: 3000
          })
        }

        // 如果切屏次数达到或超过2次，自动提交答案
        if(this.num >= 2){
          this.submission()
        }
      }
    }
 }
}

</script>
<style scoped>
  @media (min-width: 1366px) {
    .main-con { 
        width: 1000px;
      }
    }
  @media (min-width: 1600px) {
    .main-con {
      width: 1300px;
    }
  }

  .main-con {
    margin: auto;
    padding-bottom: 40px;
  }
  .index-con {
    height: 100%;
    box-sizing: border-box;
    margin: auto;
  }
  
  .aside {
    width: 64px !important;
    height: 100%;
    background-color: #334157;
    margin: 0px;
  }
  .asideshow {
    width: 240px !important;
    height: 100%;
    margin: 0px;
  }
  .index-main{
    margin-left: 20px !important;
  }
  .index-header,
  .index-main,
  .index-footer {
    padding: 0px;
    height: auto;
    margin: 0; 
  }
  .breadcrumb {
    padding: 30px 0;
  }

  

  .exam-contetn{
    display: flex;
  }
  .exam-contetn-text{
    background: #fff;
    padding: 30px;
    border-radius: 8px;
    margin-left: 30px;
  }
  .exam-contetn-text-ranking{
    font-size: 14px;
    color: black;
    margin-bottom: 16px;
  }
  .exam-contetn-text-ranking span{
    font-size: 14px;
    color: #f25901;
  }
  .exam-contetn-text-title p{
    font-size: 13px;
    color: black;
  }
  .exam-contetn-text-title img{
    width: 280px;
    margin-top: 12px;
  }
  .exam-contetn-text-radio{
    margin-top: 16px;
  }
  .el-radio-group, .el-checkbox-group{
    display: grid;
  }
 .exam-contetn-text /deep/ .el-radio__input.is-checked .el-radio__inner{
    border-color: #f15a01;
    background: #f15a01;
  }
  .exam-contetn-text /deep/  .el-checkbox__input.is-checked .el-checkbox__inner{
    border-color: #f15a01;
    background: #f15a01;
  }
  .exam-contetn-text /deep/ .el-radio__input.is-checked+.el-radio__label{
    color: #4f4f4f;
  }
  .exam-contetn-text /deep/  .el-checkbox__input.is-checked+.el-checkbox__label{
    color: #4f4f4f;
  }
  .exam-contetn-text /deep/ .el-checkbox__inner{
    border-radius: 50%;
  }
  .el-radio, .el-checkbox{
    padding: 4px 0;
    margin: 10px 0;
    text-overflow: ellipsis;
    white-space: normal;
    line-height: 18px;
    vertical-align: middle;
    display: inline-block;
  }
  .el-radio__label,.el-checkbox__label{
    font-size: 13px;
  }
  .exam-contetn-button{
    margin-top: 24px;
  }
  .el-button--small{
    padding: 10px 20px;
    width: 140px;
  }
  /* .buttons:hover{
    background: none;
    color: #606266;
    border: 1px solid #DCDFE6;
  } */
  .exam-contetn-text-input{
    display: flex;
    align-items:center;
    margin-bottom: 14px;
  }
  .exam-contetn-text-input p{
    font-size: 14px;
    color: black;
    margin-right: 6px;
  }
  .exam-contetn-text-input input{
    width: 100%;
    font-size: 12px;
  }


  .exam-contetn-item{
    background: #fff;
    padding: 30px 16px 20px;
    border-radius: 8px;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }
  .exam-contetn-item-title{
    font-size: 14px;
    color: black;
    line-height: 14px;
    font-weight: 600;
    margin-bottom: 12px;
  }
  .exam-contetn-item-score{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 14px;
  }
  .exam-contetn-item-score span{
    color: #9a9a9a;
    font-size: 12px;
  }
  .exam-contetn-item ul{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding-bottom: 16px;
    border-bottom: 1px solid #ebebeb;
  }
  .exam-contetn-item ul li{
    width: 30px;
    height: 30px;
    margin: 6.8px;
    background: #f2f2f2;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    cursor: pointer;
    position: relative;
  }
  .exam-contetn-item ul .curli{
    background: #ffeee5;
    color: #f36817;
  }
  .exam-contetn-item ul li img{
    width: 9px;
    position: absolute;
    top: 1px;
    right: 0;
  }
  .exam-contetn-item ul li p{
    font-size: 13px;
    color: black;
  }
  
  .exam-contetn-item-scantron{
    background: #f8f9fb;
    padding: 16px 10px 12px;
    border-radius: 6px;
    margin-bottom: 10px;
  }
  .exam-contetn-item-scantron-p{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
  }
  .exam-contetn-item-scantron-card{
    font-size: 13px;
    color: black;
  }
  .exam-contetn-item-scantron-type{
    font-size: 12px;
    color: #6e6e6e;
  }
  .exam-contetn-item-scantron-state{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .exam-contetn-item-scantron-state-imgs{
    display: flex;
    align-items: center;
  }
  .exam-contetn-item-scantron-state-imgs img{
    width: 14px;
    height: 14px;
    margin-right: 6px;
  }
  .exam-contetn-item-scantron-state-imgs p{
    width: 10px;
    height: 10px;
    margin-right: 6px;
    border: 1px solid #f07c34;
  }
  .exam-contetn-item-scantron-state-imgs .p2{
    border: 1px solid #acaeaf;
  }
  .exam-contetn-item-scantron-state-imgs span{
    color: #656767;
    font-size: 11px;
  }
  .exam-contetn-item-time{
    margin-top: 20px;
  }
  .exam-contetn-item-time-text{
    font-size: 12px;
    color: #6e6e6e;
    margin-bottom: 4px;
    text-align: center;

  }
  .exam-contetn-item-time-countdown{
    font-size: 18px;
    color: #fe6a00;
    text-align: center;

  }
</style>



// WEBPACK FOOTER //
// src/views/exam/examPage.vue